import React from 'react';

import { RpsiFluxDto } from 'lib_api/lib/api/gen';

import { useModal } from 'hooks/modal/useModal';

import ModalErrors from '../ModalErrors/ModalErrors';

import '../../../css/ErrorCell.less';

interface CellDetailsAndActionsProps {
  flux: RpsiFluxDto;
}

function ErrorCell({ flux }: CellDetailsAndActionsProps): React.ReactElement {
  const errorsModale = useModal();

  if (flux.errors.length) {
    return (
      <>
        <p onClick={errorsModale.open} className={'linkOnErrorOrWarning'}>
          Erreurs lors de l&apos;import ({flux.errors.length})
        </p>
        <ModalErrors
          flux={flux}
          visible={errorsModale.visible}
          close={errorsModale.close}
        />
      </>
    );
  } else {
    return <div>/</div>;
  }
}

export default ErrorCell;
